import { render, staticRenderFns } from "./harmfulFactorsDetail.vue?vue&type=template&id=0bab5177"
import script from "./harmfulFactorsDetail.vue?vue&type=script&lang=js"
export * from "./harmfulFactorsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bab5177')) {
      api.createRecord('0bab5177', component.options)
    } else {
      api.reload('0bab5177', component.options)
    }
    module.hot.accept("./harmfulFactorsDetail.vue?vue&type=template&id=0bab5177", function () {
      api.rerender('0bab5177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/harmfulFactorsDetail.vue"
export default component.exports